import { useRef } from "react";
import { Camera } from "lucide-react";
import { useEdit } from "@/components/EditContext";

export default function EditableImage({ id, defaultSrc, alt = "", className = "", imgClassName = "" }) {
  const { isEditing, content, saveContent, uploadAndGetUrl } = useEdit();
  const inputRef = useRef(null);
  const src = content[id] || defaultSrc;

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = await uploadAndGetUrl(file);
    if (url) saveContent(id, url);
  };

  // Check if this is used as a background (className contains 'absolute inset-0')
  const isBackground = className.includes('absolute') && className.includes('inset-0');

  if (!src && !isEditing) {
    return (
      <div className={`bg-w-sand/30 flex items-center justify-center ${className}`}>
        <div className="text-center">
          <Camera className="w-8 h-8 text-w-sand mx-auto" strokeWidth={1} />
          <p className="font-body text-xs text-w-muted mt-1">Immagine</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`relative group ${className}`}>
      {src ? (
        <img 
          src={src} 
          alt={alt} 
          className={`${isBackground ? 'absolute inset-0' : ''} w-full h-full object-cover ${imgClassName}`}
          loading="eager"
        />
      ) : (
        <div className={`${isBackground ? 'absolute inset-0' : ''} w-full h-full bg-w-sand/30 flex items-center justify-center`}>
          <Camera className="w-10 h-10 text-w-sand" strokeWidth={1} />
        </div>
      )}
      {isEditing && (
        <>
          <button
            onClick={() => inputRef.current?.click()}
            className="absolute inset-0 bg-w-charcoal/40 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer z-10"
            data-testid={`upload-${id}`}
          >
            <Camera className="w-8 h-8 text-white mb-1" strokeWidth={1.5} />
            <span className="font-body text-xs text-white">Carica immagine</span>
          </button>
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="hidden"
            onChange={handleUpload}
          />
        </>
      )}
    </div>
  );
}
